export default "__VITE_ASSET__BCSQ5SaW__"